// Which shape the "Modifié le …" line of the product/variation list takes.
//
// updatedAt and manualUpdatedAt answer different questions — "last written" (feed
// imports included) versus "last written by a human" — so the line has to be able to
// show one, the other, or both:
//
//   'manual' -> Modifié le <date> à <time> par <author>
//   'both'   -> Modifié le <date> à <time> + <author> le <date> à <time>
//   'global' -> Modifié le <date> à <time>
//   'none'   -> nothing to show
//
// The author is only named while still known: deleting the account nulls it without
// losing the manual date, and that case degrades to 'global'.

// The line is rendered to the minute, so two stamps in the same minute are the same
// event as far as the reader is concerned — comparing at that precision avoids
// printing one instant twice when the automated and the manual write are a second
// apart (a user edit stamps both columns).
export function isSameMinute(left, right) {
    if (!left || !right) {
        return false;
    }

    return Math.floor(new Date(left).getTime() / 60000) === Math.floor(new Date(right).getTime() / 60000);
}

export function pickLastUpdateVariant({updatedAt, manualUpdatedAt, manualUpdatedBy}) {
    const hasManual = Boolean(manualUpdatedAt && manualUpdatedBy);

    if (!hasManual) {
        return updatedAt ? 'global' : 'none';
    }

    if (!updatedAt || isSameMinute(updatedAt, manualUpdatedAt)) {
        return 'manual';
    }

    return 'both';
}

export default pickLastUpdateVariant;
